import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import { fadeUp } from "./WdMotion";

export const WdHeroSection = () => {
    const navigate = useNavigate();

    return (
        <section className="wd-hero">
            <div className="wd-container wd-hero__inner">
                <motion.div
                    className="wd-hero__copy"
                    initial="hidden"
                    animate="visible"
                    variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
                >
                    <motion.span className="wd-eyebrow" variants={fadeUp}>
                        Solutions
                    </motion.span>
                    <motion.h1 className="wd-hero__title" variants={fadeUp}>
                        Website Development that{" "}
                        <span className="wd-accent">drives growth</span>
                    </motion.h1>
                    <motion.p className="wd-hero__desc" variants={fadeUp}>
                        From CMS-powered sites to high-performance static pages, WordPress
                        platforms, and conversion-focused ecommerce — we build digital
                        experiences tailored to how your business actually works.
                    </motion.p>
                    <motion.div className="wd-hero__cta" variants={fadeUp}>
                        <Button
                            className="wd-btn wd-btn--primary"
                            onClick={() => navigate("/contact")}
                        >
                            Start Your Project <ArrowRightOutlined />
                        </Button>
                        <Button
                            className="wd-btn wd-btn--ghost"
                            onClick={() =>
                                document
                                    .getElementById("wd-cms")
                                    ?.scrollIntoView({ behavior: "smooth" })
                            }
                        >
                            Explore Categories
                        </Button>
                    </motion.div>
                </motion.div>

                <motion.div
                    className="wd-hero__visual"
                    initial={{ opacity: 0, y: 28, scale: 0.96 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
                >
                    <div className="wd-hero__orbit wd-hero__orbit--1" />
                    <div className="wd-hero__orbit wd-hero__orbit--2" />
                    <div className="wd-hero__cards">
                        {["CMS", "Static", "WordPress", "Ecommerce"].map((label, i) => (
                            <div key={label} className={`wd-hero__chip wd-hero__chip--${i}`}>
                                {label}
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
